import { render, staticRenderFns } from "./InputParts.vue?vue&type=template&id=64ec4ff1&scoped=true&lang=pug&"
import script from "./InputParts.vue?vue&type=script&lang=ts&"
export * from "./InputParts.vue?vue&type=script&lang=ts&"
import style0 from "./InputParts.vue?vue&type=style&index=0&id=64ec4ff1&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ec4ff1",
  null
  
)

export default component.exports